import React from "react";
import { Spinner } from "react-bootstrap";

function Loading({ noPadding }) {
    return <div className={`h-100 d-flex justify-content-center align-items-center ${noPadding ? '' : 'mt-5em'}`}>
        <Spinner color="black" animation="border" />
    </div>
}

export default Loading;